(ns teamoesterreich.config
  (:require [teamoesterreich.config-base :as config-base]))

; NOTE: explanation of strange config setup
;
; This strange setup together with the shadow-cljs config in project.clj
; results in a 'clean' config.js as output from `lein shadow release app`.
; This 'clean' config.js can be easily swapped for a different config after building,
; e.g. when running via Docker.

(def ^:export raw-config config-base/raw-config)
